import { useContext, useState, useEffect } from "react";
import { CheckCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";
import { Grid, Input, List, Tag, Typography } from "antd";
import IntlMessages from "../../../../util/IntlMessages";
import {
   getFormattedAddress,
   taxAccountHaveFormItems,
   getCustomerCompletionPercentage,
} from "./functions";
import { PublicFacilitiesContext } from "./context";
import { useIntl } from "react-intl";

const { Title } = Typography;
const CustomerPublicFacilitiesList = ({ taxAccounts, form }) => {
   const { selectedItem, setSelectedItem } = useContext(PublicFacilitiesContext);
   const screens = Grid.useBreakpoint();
   const intl = useIntl();

   const [searchVal, setSearchVal] = useState("");
   const [filteredTaxAccounts, setFilteredTaxAccounts] = useState(taxAccounts);

   useEffect(() => {
      setFilteredTaxAccounts(
         !searchVal
            ? taxAccounts
            : taxAccounts.filter(
                 (item) =>
                    item.code.toLowerCase().includes(searchVal) ||
                    getFormattedAddress(item).toLowerCase().includes(searchVal)
              )
      );
   }, [taxAccounts, searchVal]);

   const percentage = getCustomerCompletionPercentage(taxAccounts, form);
   let color = "default";
   if (percentage === 100) {
      color = "green";
   } else if (percentage > 0) {
      color = "orange";
   }

   return (
      <>
         <Title level={5} className="gx-mb-3">
            <IntlMessages id="tax_accounts.tax_account" />
            &nbsp;({taxAccounts?.length || 0})
            <Tag color={color} className="gx-ml-2">
               <small>{percentage}% completato</small>
            </Tag>
         </Title>

         <div
            style={
               !screens.lg
                  ? { maxHeight: 320, overflowY: "auto" }
                  : { maxHeight: 600, overflowY: "auto" }
            }
         >
            <Input
               allowClear
               placeholder={intl.formatMessage({ id: "common.search" })}
               className="gx-mb-3"
               onChange={(e) => {
                  setSearchVal(e.target.value?.toLowerCase() ?? "");
               }}
            />
            <List
               bordered
               size="small"
               itemLayout="horizontal"
               dataSource={filteredTaxAccounts}
               renderItem={(item) => {
                  const actualIndex = taxAccounts.indexOf(item);
                  return (
                     <List.Item
                        onClick={() =>
                           setSelectedItem({
                              ...selectedItem,
                              selectedIndex: actualIndex,
                           })
                        }
                        style={{
                           cursor: "pointer",
                           background:
                              selectedItem?.selectedIndex === actualIndex
                                 ? "#e6f7ff"
                                 : "transparent",
                           borderRadius: 4,
                           padding: "8px 12px",
                           border:
                              selectedItem?.selectedIndex === actualIndex
                                 ? "1px solid #91d5ff"
                                 : "1px solid transparent",
                        }}
                     >
                        <List.Item.Meta
                           avatar={
                              taxAccountHaveFormItems(item.id, form) ? (
                                 <CheckCircleTwoTone
                                    twoToneColor="#52c41a"
                                    style={{ fontSize: 18 }}
                                 />
                              ) : (
                                 <CloseCircleTwoTone
                                    twoToneColor="#ff4d4f"
                                    style={{ fontSize: 18 }}
                                 />
                              )
                           }
                           title={
                              <>
                                 <div className="gx-mb-0">
                                    <strong>{item.code}</strong>
                                 </div>
                                 <div
                                    className="gx-mb-0"
                                    style={{ lineHeight: 1.0 }}
                                 >
                                    <small
                                       dangerouslySetInnerHTML={{
                                          __html: getFormattedAddress(item),
                                       }}
                                    />
                                 </div>
                              </>
                           }
                        />
                     </List.Item>
                  );
               }}
            />
         </div>
      </>
   );
};

export default CustomerPublicFacilitiesList;
